/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type KiteInternalTrxNestedInfo = {
    BNO: string;
    PTRXHA: string;
    STP: KiteInternalTrxNestedInfo.STP;
    TRCTP: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    GL: string;
    VAL: string;
    AG: string;
    UT: number;
    SEQNO: number;
    TRCLV: number;
};

export namespace KiteInternalTrxNestedInfo {

    export enum STP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

